<template>
  <div
    :class="[
      'mt-progress relative overflow-hidden rounded-full',
      sizeClass,
      backgroundClass
    ]"
  >
    <!-- Progress Fill -->
    <div
      :class="[
        'h-full transition-all duration-500 ease-out',
        fillColorClass,
        striped ? 'bg-[length:20px_20px] animate-progress-stripes' : ''
      ]"
      :style="{ width: progress + '%' }"
    ></div>

    <!-- Percent Label -->
    <span
      v-if="showLabel"
      class="absolute inset-0 flex items-center justify-center text-[0.7rem] font-semibold"
      :class="labelColorClass"
    >
      {{ progress }}%
    </span>
  </div>
</template>


<script setup>
const props = defineProps({
  progress: { type: Number, required: true },
  size: { type: String, default: "md" },       // xs | sm | md | lg
  striped: { type: Boolean, default: false },   // diagonal stripe animation
  showLabel: { type: Boolean, default: true },  // show 75% text
  variant: { type: String, default: "auto" }    // auto | success | warning | danger | primary
});

// BAR SIZE
const sizeClass = {
  xs: "h-2",
  sm: "h-3",
  md: "h-4",
  lg: "h-5"
}[props.size];

// BACKGROUND TRACK - darker gray for better visibility on white backgrounds
const backgroundClass = "bg-gray-300 dark:bg-gray-700";

// COLOR LOGIC
function getColor() {
  if (props.variant !== "auto") return props.variant; // override

  if (props.progress < 30) return "danger";
  if (props.progress < 70) return "warning";
  return "success";
}

const variant = getColor();

// FILL COLOUR CLASS
const fillColorClass = {
  success: "bg-green-500",
  warning: "bg-yellow-400",
  danger: "bg-red-500",
  primary: "bg-blue-600",
}[variant];

// LABEL COLOR - use dark text when progress is low so it's visible on the gray track
const labelColorClass = props.progress < 50
  ? "text-gray-700"
  : {
      success: "text-white",
      warning: "text-gray-900",
      danger: "text-white",
      primary: "text-white",
    }[variant] || "text-gray-900";
</script>
